import { BasecampRole } from "@utils/types";
import { Navigate } from "react-router-dom";

import { useBasecampRoles } from "@hooks/useBasecampRoles";

export const DefaultRedirect: React.FC = () => {
  const roles = useBasecampRoles();
  if (roles.includes(BasecampRole.ADMIN) || roles.includes(BasecampRole.ENABLEMENT_ADMIN))
    return <Navigate to="/organizations" replace />;
  if (roles.includes(BasecampRole.ENTERPRISE_ADMIN)) return <Navigate to="/prompts" replace />;
  if (roles.includes(BasecampRole.NOTIFICATIONS_ADMIN))
    return <Navigate to="/notifications/community-digest" replace />;
  // Chat admin is the narrowest role and cannot open /organizations, so it
  // needs its own landing route rather than the fallback.
  if (roles.includes(BasecampRole.CHAT_ADMIN)) return <Navigate to="/expert-chats" replace />;
  return <Navigate to="/organizations" replace />;
};
